import styled from 'styled-components';

export const Bold = styled.b``;

export const Paragraph = styled.p`
  b {
    font-size: 15px !important;
    font-family: ${props => props.theme.fonts.montserrat.bold};
  }
`;
